// extracted by mini-css-extract-plugin
export default {"backdrop":"DeleteNotifier_backdrop__Yl0nF","modal":"DeleteNotifier_modal__jb7xl","footer":"DeleteNotifier_footer__-FReW"};